import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function RefreshIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M2 6.778s.073-.52 2.182-2.667a5.33 5.33 0 0 1 7.636 0 5.5 5.5 0 0 1 1.448 2.667M2 6.778V3.11m0 3.667h3.6M14 9.222s-.073.52-2.182 2.667a5.33 5.33 0 0 1-7.636 0 5.5 5.5 0 0 1-1.448-2.667m11.266 0v3.667m0-3.667h-3.6" /></svg>
  );
}

export default RefreshIcon;
